import {
  configApiRef,
  IdentityApi,
  identityApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { WorkloadClient } from '@internal/workload-api-helper';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { FieldValidation } from '@rjsf/utils';

import { useForm } from 'react-hook-form';
import { validateField } from '../helper';

let config: any;
let identity: IdentityApi;
let formContext: any;
let workloadClient: WorkloadClient;
export const GovernanceGroupMembershipExtensionSchema: CustomFieldExtensionSchema =
  {
    returnValue: { type: 'string' },
  };

export const GovernanceGroupMembership = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => {
  // Set up variables for accounts-api validation call
  config = useApi(configApiRef);
  identity = useApi(identityApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  workloadClient = new WorkloadClient(config, oauthApi);

  formContext = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    shouldUnregister: true,
    defaultValues: {
      existing_repository: 'No',
      vpc_required: 'No',
      public_subnet: 'No',
      repository_creation_enabled: 'No',
      governance_group_membership: [''],
    },
  });

  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
    >
      <InputLabel htmlFor="governanceGroupMembershipInput">Member</InputLabel>
      <Input
        id="governanceGroupMembershipInput"
        defaultValue={formData}
        onChange={e => onChange(e.target?.value)}
      />
    </FormControl>
  );
};

/*
 This is a validation function that will run when the form is submitted.
  You will get the value from the `onChange` handler before as the value here to make sure that the types are aligned\
*/
export const validateGovernanceGroupMembership = async (
  value: any,
  validation: FieldValidation,
) => {
  for (const member of value as Array<string>) {
    const index: number = (value as Array<string>).indexOf(member);
    formContext.setValue('governance_group_membership', value);
    const apiValidation = {
      workloadClient: workloadClient,
      config: config,
      identity: identity,
      form: formContext,
    };
    const errorMessage = await validateField(
      `governance_group_membership${index}`,
      member,
      apiValidation,
    );
    if (errorMessage) validation.addError(errorMessage);
  }
};
